<template>
  <div class="history" v-if="sendedGifts && sendedGifts.length > 0">
    <div class="history__arrow" @click="move(-1)"><img src="../assets/image/arrow_left.png"/></div>
    <div class="history__center" id="history__center">
      <div class="history__center__field" id="history__center__field">
        <div class="history__center__field__item" v-for="(item, index) in sendedGifts" :key="index">
          <b-image class="history__center__field__item__user" :src="item.photoURL" :rounded="true" ratio="20by5"/>
          <b-image class="history__center__field__item__gift" :src="item.iconURL" :rounded="true"/>
        </div>
      </div>    
    </div>
    <div class="history__arrow" @click="move(1)"><img src="../assets/image/arrow_right.png"/></div>
  </div>
</template>

<script>
import { getUserDoc } from '@/services/userServices';

export default {
  name: 'GiftHistory',
  data() {
    return {
      sendedGifts: [],
      pointer: 0
    };
  },
  computed: {
    defaultPhotoURL() {
      return 'https://firebasestorage.googleapis.com/v0/b/pandora-988f8.appspot.com/o/all%2Fdefault-user-icon.png?alt=media&token=4a1a4307-1990-4c99-a944-9b8d289e1a50';
    }
  },
  methods: {
    async setGifts(gifts) {
      if (gifts) {
        await Promise.all(gifts.map(async item => {
          return new Promise((resolve, reject) => {
            getUserDoc(item.userId).then(user => {
              item.photoURL = user && user.photoURL ? user.photoURL : this.defaultPhotoURL;
              resolve();
            }).catch(e => {
              reject(e);
            })
          });
        }));
        this.sendedGifts = gifts;
      }
    },
    move(point) {
      let base = document.getElementById("history__center");
      let field = document.getElementById("history__center__field");
      let maxPoint = Math.ceil(field.scrollWidth / base.offsetWidth) - 1;
      let nextPoint = this.pointer + point;

      if (nextPoint < 0 || nextPoint > maxPoint) {
        return;
      }
       document.getElementById("history__center").scrollLeft = field.offsetWidth * nextPoint;
      this.pointer = nextPoint;
    }
  }
}
</script>

<style lang="scss" scoped>
.history {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 60px;
  background: #FFFFFF;
  border-bottom: 1px solid #E3DBDB;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__arrow {
    padding-left: 15px;
    padding-right: 15px;

    & img {
      width: 12px;
      height: 12px;
    }
  }

  &__center {
    width: 100%;
    overflow-x: hidden;
 
    &__field {
      height: 100%;
      display: flex;
      flex-shrink: 0;
      justify-content: flex-start;
      align-items: center;

      &__item {
        height: 32px;
        width: 70px;
        background: #48C864;
        border: 1px solid #2AAD47;
        border-radius: 16px;
        margin-left: 10px;
        padding-left: 10px;
        padding-right: 10px;

        display: flex;
        justify-content: space-between;
        align-items: center;

        &__user {
          height: 20px;
          width: 20px;
        }

        &__gift {
          height: 20px;
          width: 20px;
        }
      }
    }
  }
}
</style>
